var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#F98700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34049 15.66C7.71126 14.0276 6.45831 12.059 5.66928 9.89182C5.23519 8.70697 5.63292 7.40545 6.52534 6.51303L7.07761 5.96151C7.22609 5.81274 7.40245 5.69471 7.59659 5.61417C7.79074 5.53364 7.99887 5.49219 8.20905 5.49219C8.41924 5.49219 8.62736 5.53364 8.82151 5.61417C9.01566 5.69471 9.19202 5.81274 9.34049 5.96151L10.6337 7.2547C10.7824 7.40317 10.9005 7.57953 10.981 7.77368C11.0615 7.96782 11.103 8.17595 11.103 8.38613C11.103 8.59632 11.0615 8.80445 10.981 8.99859C10.9005 9.19274 10.7824 9.3691 10.6337 9.51757L10.3155 9.83576C10.1881 9.96309 10.0871 10.1143 10.0182 10.2806C9.94925 10.447 9.91377 10.6254 9.91377 10.8055C9.91377 10.9855 9.94925 11.1639 10.0182 11.3303C10.0871 11.4966 10.1881 11.6478 10.3155 11.7752L13.2246 14.685C13.3519 14.8124 13.5031 14.9134 13.6695 14.9823C13.8359 15.0512 14.0142 15.0867 14.1943 15.0867C14.3744 15.0867 14.5527 15.0512 14.7191 14.9823C14.8855 14.9134 15.0366 14.8124 15.164 14.685L15.4829 14.3668C15.6314 14.218 15.8078 14.1 16.0019 14.0195C16.196 13.9389 16.4042 13.8975 16.6144 13.8975C16.8245 13.8975 17.0327 13.9389 17.2268 14.0195C17.421 14.1 17.5973 14.218 17.7458 14.3668L19.039 15.66C19.1878 15.8085 19.3058 15.9848 19.3863 16.179C19.4669 16.3731 19.5083 16.5812 19.5083 16.7914C19.5083 17.0016 19.4669 17.2097 19.3863 17.4039C19.3058 17.598 19.1878 17.7744 19.039 17.9229L18.4875 18.4744C17.595 19.3676 16.2935 19.7653 15.1087 19.3312C12.9415 18.5422 10.9729 17.2892 9.34049 15.66Z",
    stroke: "#F98700",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.863c5bbef24c2d1a53d118744cb89fcd.svg";
export { ForwardRef as ReactComponent };